const triggerForm = {
  bindings: {
    onSelect: '&',
    triggers: '<',
    viewMode: '<',
    conditions: '<',
    condition: '<',
    variables: '<',
    environmentVariableObjects: '<'
  },
  templateUrl:
    '/modules/pis-tool/conditions/condition-form/trigger-form/trigger-form.html',
  controller: 'TriggerFormController',
};

angular
  .module('pis-tool.module')
  .component('triggerForm', triggerForm);
